var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionProfileClone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.34375V4.6875H2.125C1.21094 4.6875 0.5 5.42383 0.5 6.3125V12C0.5 12.9141 1.21094 13.625 2.125 13.625H7.8125C8.70117 13.625 9.4375 12.9141 9.4375 12V10.375H5.78125C4.63867 10.375 3.75 9.48633 3.75 8.34375ZM11.875 0.625H6.1875C5.27344 0.625 4.5625 1.36133 4.5625 2.25V7.9375C4.5625 8.85156 5.27344 9.5625 6.1875 9.5625H11.875C12.7637 9.5625 13.5 8.85156 13.5 7.9375V2.25C13.5 1.36133 12.7637 0.625 11.875 0.625Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionProfileClone);
export default __webpack_public_path__ + "static/media/connection-profile-clone.4fb9606badb31e7ba57d34b0ff0d15a2.svg";
export { ForwardRef as ReactComponent };